export type Currency = {
  iso: string;
  symbol: string;
};

const AED: Currency = { iso: 'AED', symbol: '' };
const ALL: Currency = { iso: 'ALL', symbol: 'Lek' };
const AMD: Currency = { iso: 'AMD', symbol: '' };
const ANG: Currency = { iso: 'ANG', symbol: '' };
const AOA: Currency = { iso: 'AOA', symbol: '' };
const ARS: Currency = { iso: 'ARS', symbol: '$' };
const AUD: Currency = { iso: 'AUD', symbol: '$' };
const AWG: Currency = { iso: 'AWG', symbol: 'ƒ' };
const AZN: Currency = { iso: 'AZN', symbol: 'ман' };
const BAM: Currency = { iso: 'BAM', symbol: 'KM' };
const BBD: Currency = { iso: 'BBD', symbol: '$' };
const BDT: Currency = { iso: 'BDT', symbol: '' };
const BGN: Currency = { iso: 'BGN', symbol: 'лв' };
const BHD: Currency = { iso: 'BHD', symbol: '' };
const BIF: Currency = { iso: 'BIF', symbol: '' };
const BMD: Currency = { iso: 'BMD', symbol: '$' };
const BND: Currency = { iso: 'BND', symbol: '$' };
const BOB: Currency = { iso: 'BOB', symbol: '$b' };
const BRL: Currency = { iso: 'BRL', symbol: 'R$' };
const BSD: Currency = { iso: 'BSD', symbol: '$' };
const BTC: Currency = { iso: 'BTC', symbol: '' };
const BTN: Currency = { iso: 'BTN', symbol: '' };
const BWP: Currency = { iso: 'BWP', symbol: 'P' };
const BYR: Currency = { iso: 'BYR', symbol: 'p.' };
const BZD: Currency = { iso: 'BZD', symbol: 'BZ$' };
const CAD: Currency = { iso: 'CAD', symbol: '$' };
const CDF: Currency = { iso: 'CDF', symbol: '' };
const CHF: Currency = { iso: 'CHF', symbol: 'SFr' };
const CLF: Currency = { iso: 'CLF', symbol: '' };
const CLP: Currency = { iso: 'CLP', symbol: '$' };
const CNY: Currency = { iso: 'CNY', symbol: '¥' };
const COP: Currency = { iso: 'COP', symbol: '$' };
const CRC: Currency = { iso: 'CRC', symbol: '₡' };
const CUP: Currency = { iso: 'CUP', symbol: '₱' };
const CVE: Currency = { iso: 'CVE', symbol: '' };
const CZK: Currency = { iso: 'CZK', symbol: 'Kč' };
const DJF: Currency = { iso: 'DJF', symbol: '' };
const DKK: Currency = { iso: 'DKK', symbol: 'kr' };
const DOP: Currency = { iso: 'DOP', symbol: 'RD$' };
const DZD: Currency = { iso: 'DZD', symbol: '' };
const EEK: Currency = { iso: 'EEK', symbol: 'kr' };
const EGP: Currency = { iso: 'EGP', symbol: '£' };
const ERN: Currency = { iso: 'ERN', symbol: '' };
const ETB: Currency = { iso: 'ETB', symbol: '' };
const EUR: Currency = { iso: 'EUR', symbol: '€' };
const FJD: Currency = { iso: 'FJD', symbol: '$' };
const FKP: Currency = { iso: 'FKP', symbol: '£' };
const GBP: Currency = { iso: 'GBP', symbol: '£' };
const GEL: Currency = { iso: 'GEL', symbol: '' };
const GHS: Currency = { iso: 'GHS', symbol: '' };
const GIP: Currency = { iso: 'GIP', symbol: '£' };
const GMD: Currency = { iso: 'GMD', symbol: '' };
const GNF: Currency = { iso: 'GNF', symbol: '' };
const GTQ: Currency = { iso: 'GTQ', symbol: 'Q' };
const GYD: Currency = { iso: 'GYD', symbol: '$' };
const HKD: Currency = { iso: 'HKD', symbol: '$' };
const HNL: Currency = { iso: 'HNL', symbol: 'L' };
const HRK: Currency = { iso: 'HRK', symbol: 'kn' };
const HTG: Currency = { iso: 'HTG', symbol: '' };
const HUF: Currency = { iso: 'HUF', symbol: 'Ft' };
const IDR: Currency = { iso: 'IDR', symbol: 'Rp' };
const ILS: Currency = { iso: 'ILS', symbol: '₪' };
const INR: Currency = { iso: 'INR', symbol: '₹' };
const IQD: Currency = { iso: 'IQD', symbol: '' };
const IRR: Currency = { iso: 'IRR', symbol: '﷼' };
const ISK: Currency = { iso: 'ISK', symbol: 'kr' };
const JEP: Currency = { iso: 'JEP', symbol: '£' };
const JMD: Currency = { iso: 'JMD', symbol: 'J$' };
const JOD: Currency = { iso: 'JOD', symbol: '' };
const JPY: Currency = { iso: 'JPY', symbol: '¥' };
const KES: Currency = { iso: 'KES', symbol: '' };
const KGS: Currency = { iso: 'KGS', symbol: 'лв' };
const KHR: Currency = { iso: 'KHR', symbol: '៛' };
const KMF: Currency = { iso: 'KMF', symbol: '' };
const KPW: Currency = { iso: 'KPW', symbol: '₩' };
const KRW: Currency = { iso: 'KRW', symbol: '₩' };
const KWD: Currency = { iso: 'KWD', symbol: '' };
const KYD: Currency = { iso: 'KYD', symbol: '$' };
const KZT: Currency = { iso: 'KZT', symbol: 'лв' };
const LAK: Currency = { iso: 'LAK', symbol: '₭' };
const LBP: Currency = { iso: 'LBP', symbol: '£' };
const LKR: Currency = { iso: 'LKR', symbol: '₨' };
const LRD: Currency = { iso: 'LRD', symbol: '$' };
const LSL: Currency = { iso: 'LSL', symbol: '' };
const LTL: Currency = { iso: 'LTL', symbol: 'Lt' };
const LVL: Currency = { iso: 'LVL', symbol: 'Ls' };
const LYD: Currency = { iso: 'LYD', symbol: '' };
const MAD: Currency = { iso: 'MAD', symbol: '' };
const MDL: Currency = { iso: 'MDL', symbol: '' };
const MGA: Currency = { iso: 'MGA', symbol: '' };
const MKD: Currency = { iso: 'MKD', symbol: 'ден' };
const MMK: Currency = { iso: 'MMK', symbol: '' };
const MNT: Currency = { iso: 'MNT', symbol: '₮' };
const MOP: Currency = { iso: 'MOP', symbol: '' };
const MRO: Currency = { iso: 'MRO', symbol: '' };
const MTL: Currency = { iso: 'MTL', symbol: '' };
const MUR: Currency = { iso: 'MUR', symbol: '₨' };
const MVR: Currency = { iso: 'MVR', symbol: '' };
const MWK: Currency = { iso: 'MWK', symbol: '' };
const MXN: Currency = { iso: 'MXN', symbol: '$' };
const MYR: Currency = { iso: 'MYR', symbol: 'RM' };
const MZN: Currency = { iso: 'MZN', symbol: 'MT' };
const NAD: Currency = { iso: 'NAD', symbol: '$' };
const NGN: Currency = { iso: 'NGN', symbol: '₦' };
const NIO: Currency = { iso: 'NIO', symbol: 'C$' };
const NOK: Currency = { iso: 'NOK', symbol: 'kr' };
const NPR: Currency = { iso: 'NPR', symbol: '₨' };
const NZD: Currency = { iso: 'NZD', symbol: '$' };
const OMR: Currency = { iso: 'OMR', symbol: '﷼' };
const PAB: Currency = { iso: 'PAB', symbol: 'B/.' };
const PEN: Currency = { iso: 'PEN', symbol: 'S/.' };
const PGK: Currency = { iso: 'PGK', symbol: '' };
const PHP: Currency = { iso: 'PHP', symbol: '₱' };
const PKR: Currency = { iso: 'PKR', symbol: '₨' };
const PLN: Currency = { iso: 'PLN', symbol: 'zł' };
const PYG: Currency = { iso: 'PYG', symbol: 'Gs' };
const QAR: Currency = { iso: 'QAR', symbol: '﷼' };
const RMB: Currency = { iso: 'RMB', symbol: '¥' };
const RON: Currency = { iso: 'RON', symbol: 'lei' };
const RSD: Currency = { iso: 'RSD', symbol: 'Дин.' };
const RUB: Currency = { iso: 'RUB', symbol: 'руб' };
const RWF: Currency = { iso: 'RWF', symbol: '' };
const SAR: Currency = { iso: 'SAR', symbol: '﷼' };
const SBD: Currency = { iso: 'SBD', symbol: '$' };
const SCR: Currency = { iso: 'SCR', symbol: '₨' };
const SDG: Currency = { iso: 'SDG', symbol: '' };
const SDR: Currency = { iso: 'SDR', symbol: '' };
const SEK: Currency = { iso: 'SEK', symbol: 'kr' };
const SGD: Currency = { iso: 'SGD', symbol: '$' };
const SHP: Currency = { iso: 'SHP', symbol: '£' };
const SLL: Currency = { iso: 'SLL', symbol: '' };
const SOS: Currency = { iso: 'SOS', symbol: 'S' };
const SRD: Currency = { iso: 'SRD', symbol: '$' };
const STD: Currency = { iso: 'STD', symbol: '' };
const SVC: Currency = { iso: 'SVC', symbol: '$' };
const SYP: Currency = { iso: 'SYP', symbol: '£' };
const SZL: Currency = { iso: 'SZL', symbol: '' };
const THB: Currency = { iso: 'THB', symbol: '฿' };
const TJS: Currency = { iso: 'TJS', symbol: '' };
const TMT: Currency = { iso: 'TMT', symbol: '' };
const TND: Currency = { iso: 'TND', symbol: '' };
const TOP: Currency = { iso: 'TOP', symbol: '' };
const TRY: Currency = { iso: 'TRY', symbol: '' };
const TTD: Currency = { iso: 'TTD', symbol: 'TT$' };
const TWD: Currency = { iso: 'TWD', symbol: 'NT$' };
const TZS: Currency = { iso: 'TZS', symbol: '' };
const UAH: Currency = { iso: 'UAH', symbol: '₴' };
const UGX: Currency = { iso: 'UGX', symbol: '' };
const USD: Currency = { iso: 'USD', symbol: '$' };
const UYU: Currency = { iso: 'UYU', symbol: '$U' };
const UZS: Currency = { iso: 'UZS', symbol: 'лв' };
const VEF: Currency = { iso: 'VEF', symbol: 'Bs' };
const VND: Currency = { iso: 'VND', symbol: '₫' };
const VUV: Currency = { iso: 'VUV', symbol: '' };
const WST: Currency = { iso: 'WST', symbol: '' };
const XAF: Currency = { iso: 'XAF', symbol: '' };
const XAG: Currency = { iso: 'XAG', symbol: '' };
const XAU: Currency = { iso: 'XAU', symbol: '' };
const XCD: Currency = { iso: 'XCD', symbol: '$' };
const XDR: Currency = { iso: 'XDR', symbol: '' };
const XOF: Currency = { iso: 'XOF', symbol: '' };
const XPF: Currency = { iso: 'XPF', symbol: '' };
const YER: Currency = { iso: 'YER', symbol: '﷼' };
const ZAR: Currency = { iso: 'ZAR', symbol: '' };
const ZMK: Currency = { iso: 'ZMK', symbol: '' };
const ZMW: Currency = { iso: 'ZMW', symbol: '' };
const ZWL: Currency = { iso: 'ZWL', symbol: 'Z$' };

export const currencies = {
  AED,
  ALL,
  AMD,
  ANG,
  AOA,
  ARS,
  AUD,
  AWG,
  AZN,
  BAM,
  BBD,
  BDT,
  BGN,
  BHD,
  BIF,
  BMD,
  BND,
  BOB,
  BRL,
  BSD,
  BTC,
  BTN,
  BWP,
  BYR,
  BZD,
  CAD,
  CDF,
  CHF,
  CLF,
  CLP,
  CNY,
  COP,
  CRC,
  CUP,
  CVE,
  CZK,
  DJF,
  DKK,
  DOP,
  DZD,
  EEK,
  EGP,
  ERN,
  ETB,
  EUR,
  FJD,
  FKP,
  GBP,
  GEL,
  GHS,
  GIP,
  GMD,
  GNF,
  GTQ,
  GYD,
  HKD,
  HNL,
  HRK,
  HTG,
  HUF,
  IDR,
  ILS,
  INR,
  IQD,
  IRR,
  ISK,
  JEP,
  JMD,
  JOD,
  JPY,
  KES,
  KGS,
  KHR,
  KMF,
  KPW,
  KRW,
  KWD,
  KYD,
  KZT,
  LAK,
  LBP,
  LKR,
  LRD,
  LSL,
  LTL,
  LVL,
  LYD,
  MAD,
  MDL,
  MGA,
  MKD,
  MMK,
  MNT,
  MOP,
  MRO,
  MTL,
  MUR,
  MVR,
  MWK,
  MXN,
  MYR,
  MZN,
  NAD,
  NGN,
  NIO,
  NOK,
  NPR,
  NZD,
  OMR,
  PAB,
  PEN,
  PGK,
  PHP,
  PKR,
  PLN,
  PYG,
  QAR,
  RMB,
  RON,
  RSD,
  RUB,
  RWF,
  SAR,
  SBD,
  SCR,
  SDG,
  SDR,
  SEK,
  SGD,
  SHP,
  SLL,
  SOS,
  SRD,
  STD,
  SVC,
  SYP,
  SZL,
  THB,
  TJS,
  TMT,
  TND,
  TOP,
  TRY,
  TTD,
  TWD,
  TZS,
  UAH,
  UGX,
  USD,
  UYU,
  UZS,
  VEF,
  VND,
  VUV,
  WST,
  XAF,
  XAG,
  XAU,
  XCD,
  XDR,
  XOF,
  XPF,
  YER,
  ZAR,
  ZMK,
  ZMW,
  ZWL,
} as const;
